import Phaser from "phaser";

class RPFScene extends Phaser.Scene {
  constructor(name, args, onCreate) {
    super(name);
    this.onCreate = onCreate;
    this.config = args
  }
  preload() {
    if(this.config?.preload) {
      this.config.preload.bind(this)()
    }
  }
  create(data = {}) {
    if(this.config?.create) {
      this.config.create.bind(this)()
    }
    this.onCreate(data);
  }
}

export default RPFScene;
